import * as net from 'util/Net';

export interface InventoryConfigParams {
  enableArchiveEntityInContainerOption?: boolean;
}

export function updateInventoryConfig(payload: InventoryConfigParams): Promise<void> {
  return net.patchJSONPromise({
    url: '/1/api/inventory-config',
    data: payload,
  });
}
